import * as types from '../../../../store/mutation-types';

export default {
  props: ['plotCartSize', 'creatingPurchase'],
  methods: {
    close() {
      this.$store.dispatch('cancelPurchase');
    },
    openPurchaseSidebar() {
      if (!this.creatingPurchase) {
        this.$store.commit(types.TOGGLE_PURCHASE_SIDEBAR, true);
      }
    },
  },
};
